var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_1240_206)" } }, [
        _c("path", {
          attrs: {
            d: "M9.375 0.937701C9.375 0.647662 9.24316 0.375201 9.01465 0.19942C8.78613 0.0236387 8.49023 -0.0408145 8.20898 0.029498L2.93848 1.34786C2.31445 1.50313 1.875 2.06563 1.875 2.71016V13.1252H0.9375C0.418945 13.1252 0 13.5441 0 14.0627C0 14.5813 0.418945 15.0002 0.9375 15.0002H2.8125H8.4375H9.375V14.0627V0.937701ZM7.5 7.5002C7.5 8.01876 7.18652 8.4377 6.79688 8.4377C6.40723 8.4377 6.09375 8.01876 6.09375 7.5002C6.09375 6.98165 6.40723 6.5627 6.79688 6.5627C7.18652 6.5627 7.5 6.98165 7.5 7.5002ZM10.3125 3.7502H13.125V14.0627C13.125 14.5813 13.5439 15.0002 14.0625 15.0002H15.9375C16.4561 15.0002 16.875 14.5813 16.875 14.0627C16.875 13.5441 16.4561 13.1252 15.9375 13.1252H15V3.7502C15 2.71602 14.1592 1.8752 13.125 1.8752H10.3125V3.7502Z",
            fill: "black",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_1240_206" } }, [
          _c("rect", { attrs: { width: "16", height: "16", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }